import React from 'react'

import useBooleanState from '../../../../../../hooks/useBooleanState'
import SidebarFooter from '../../SidebarFooter/SidebarFooter'

import {DeletePipelineDialog} from './DeletePipelineDialog/DeletePipelineDialog'

import IconButton from 'src/components/common/IconButton/IconButton'

function PipelineSettingsFooter() {
  const title = 'Delete pipeline'
  const [isDialogShown, showDialog, hideDialog] = useBooleanState()

  return (
    <SidebarFooter>
      <IconButton title={title} icon={'trash'} onClick={showDialog} danger>
        {title}
      </IconButton>
      <DeletePipelineDialog show={isDialogShown} onCloseAttempt={hideDialog} />
    </SidebarFooter>
  )
}

export default React.memo(PipelineSettingsFooter)
